import { Component } from 'solid-js'

interface Props {
  title: string
  value: string
  onClick: (value: string, replacePrompt: boolean) => void
  replacePrompt?: boolean
  isSelected?: boolean
}

const GenerateImageOptionButton: Component<Props> = (props) => {
  return (
    <button
      onClick={() => props.onClick(props.value, props.replacePrompt || false)}
      class={`inline-flex h-9 items-center gap-[7px] rounded-full px-4 font-rajdhani text-[13px] font-semibold tracking-[0.3px] transition-all duration-150 ${
        props.isSelected
          ? 'border border-[rgba(138,43,226,0.6)] bg-[rgba(138,43,226,0.3)] text-white shadow-[0_4px_12px_rgba(138,43,226,0.25)]'
          : 'border border-[var(--cf-hairline)] bg-[rgba(255,255,255,0.04)] text-[rgba(255,255,255,0.75)] hover:border-[rgba(138,43,226,0.35)] hover:bg-[rgba(138,43,226,0.15)] hover:text-white'
      }`}
    >
      <span
        class={`h-[6px] w-[6px] flex-shrink-0 rounded-full transition-all duration-150 ${
          props.isSelected
            ? 'bg-[var(--cf-cyan)] shadow-[0_0_6px_var(--cf-cyan)]'
            : 'bg-[rgba(255,255,255,0.2)]'
        }`}
      />
      {props.title}
    </button>
  )
}

export default GenerateImageOptionButton
